export default "__VITE_ASSET__BVnaWBzh__"